export default __webpack_public_path__ + "static/media/arrowBottomIconSharpSmall.99081cae.svg";